import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_echart = _resolveComponent("echart")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_echart, {
      class: "chart",
      option: _ctx.option,
      initOptions: _ctx.initOptions,
      style: {"width":"100%","height":"460px"}
    }, null, 8, ["option", "initOptions"])
  ]))
}